import mod from "-!../node_modules/vue-loader/lib/index.js!../node_modules/vue-markdown-loader/lib/markdown-compiler.js??ref--1-1!./input.md?vue&type=script&lang=js&"; export default mod; export * from "-!../node_modules/vue-loader/lib/index.js!../node_modules/vue-markdown-loader/lib/markdown-compiler.js??ref--1-1!./input.md?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./docs/input.md?vue&type=script&lang=js&
// module id = null
// module chunks = 